import React from "react";
import axios from "axios";

import {
  Box,
  Typography,
  Button
} from "@mui/material";

import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import AudiotrackIcon from "@mui/icons-material/Audiotrack";
import MovieIcon from "@mui/icons-material/Movie";
import DownloadIcon from "@mui/icons-material/Download";
import PictureAsPdfIcon  from "@mui/icons-material/InsertDriveFile";

const s3Axios = axios.create({
  withCredentials: false,
  headers: {}
});

const removeTimestampPrefix = (fileName) => {
  if (!fileName) return "file";
  return fileName.replace(/^\d+-/, '');
};

const forceDownloadAxios = async (url, fileName) => {
  try {

    const cleanFileName =
      removeTimestampPrefix(fileName);

    const res = await s3Axios.get(url, {
      responseType: "blob",
      params: { t: Date.now() }
    });

    const blobUrl =
      URL.createObjectURL(res.data);

    const a = document.createElement("a");

    a.href = blobUrl;
    a.download = cleanFileName;

    document.body.appendChild(a);

    a.click();

    a.remove();

    URL.revokeObjectURL(blobUrl);

  } catch (error) {

    console.error("Download failed:", error);

  }
};

const getFileIcon = (type) => {

  if (!type)
    return <InsertDriveFileIcon />;

  if (type.startsWith("audio/")) {
    return (
      <AudiotrackIcon
        sx={{ color: '#7DD3FC' }}
      />
    );
  }

  if (type.startsWith("video/")) {
    return (
      <MovieIcon
        sx={{ color: '#7DD3FC' }}
      />
    );
  }

  if (type === "application/pdf") {
    return (
      <PictureAsPdfIcon
        sx={{ color: '#F43F5E' }}
      />
    );
  }

  return (
    <InsertDriveFileIcon
      sx={{ color: '#64748B' }}
    />
  );
};

const AttachmentPreview = ({
  attachments = []
}) => {

  if (!attachments.length) return null;

  return (
    <Box
      sx={{
        border: '1px solid #E2E8F0',
        borderRadius: '12px',
        padding: '12px',
        background: '#F8FAFC',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        maxWidth: '380px'
      }}
    >

      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: 700,
          color: '#475569'
        }}
      >
        Attachments ({attachments.length})
      </Typography>

      {attachments.map((attachment, index) => {

        const displayName =
          removeTimestampPrefix(
            attachment.filename
          );

        return (

          <Box
            key={index}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              background: '#FFFFFF',
              border: '1px solid #E2E8F0',
              borderRadius: '8px',
              padding: '10px',
              gap: '10px'
            }}
          >

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                minWidth: 0,
                flex: 1
              }}
            >

              {getFileIcon(
                attachment.filetype
              )}

              <Box sx={{ minWidth: 0 }}>

                <Typography
                  sx={{
                    fontSize: '13px',
                    fontWeight: 600,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {displayName}
                </Typography>

                <Typography
                  sx={{
                    fontSize: '11px',
                    color: '#64748B'
                  }}
                >
                  {attachment.filetype}
                </Typography>

              </Box>

            </Box>

            <Button
              size="small"
              variant="contained"
              startIcon={
                <DownloadIcon />
              }
              onClick={() =>
                forceDownloadAxios(
                  attachment.fileUrl,
                  attachment.filename
                )
              }
              sx={{
                textTransform: 'none',
                borderRadius: '8px',
                boxShadow: 'none'
              }}
            >
              Download
            </Button>

          </Box>

        );
      })}

    </Box>
  );
};

export default React.memo(
  AttachmentPreview
);